import createIcon from '../../createIcon';

/**
 * @component @name CorporateFare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgN1YzSDJWMjFIMjJWN0gxMlpNMTAgMTlINFYxN0gxMFYxOVpNMTAgMTVINFYxM0gxMFYxNVpNMTAgMTFINFY5SDEwVjExWk0xMCA3SDRWNUgxMFY3Wk0yMCAxOUgxMlY5SDIwVjE5Wk0xOCAxMUgxNFYxM0gxOFYxMVpNMTggMTVIMTRWMTdIMThWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CorporateFare = createIcon('CorporateFare', [
  [
    'path',
    {
      d: 'M12 7V3H2V21H22V7H12ZM10 19H4V17H10V19ZM10 15H4V13H10V15ZM10 11H4V9H10V11ZM10 7H4V5H10V7ZM20 19H12V9H20V19ZM18 11H14V13H18V11ZM18 15H14V17H18V15Z',
      key: 'aohkb2',
    },
  ],
]);

export default CorporateFare;
